import { useEffect, useState } from 'preact/hooks';
import { ReviewSorting } from 'types/review';
import { AnyExtendedWidgetSettingsWithFilters } from 'types/settings';

import { useSettings } from 'components/SettingsProvider';

import { useGetSortingOptions } from '../widgets/ReviewsWidget/types/sorting';

export function useSorting() {
  const {
    default_sort_order,
    enable_helpful_filter,
    enable_rating_asc_filter,
    enable_rating_desc_filter,
    enable_recent_filter,
  } = useSettings<AnyExtendedWidgetSettingsWithFilters>();

  const sortingOptions = useGetSortingOptions({
    enable_helpful_filter,
    enable_rating_asc_filter,
    enable_rating_desc_filter,
    enable_recent_filter,
  });

  const [sortBy, setSortBy] = useState<ReviewSorting>(default_sort_order);

  useEffect(() => {
    setSortBy(default_sort_order);
  }, [default_sort_order]);

  return {
    sortBy,
    sortingOptions,
    changeSorting: setSortBy,
  };
}
